import * as React from "react";
import { connect } from "react-redux";
import { RootState, Action } from "../../redux";

const s = require("./app.scss");

export interface Props {
    value: number;
    dispatch: (action: Action<any>) => any;
}

class App extends React.Component<Props, {}> {

    render() {
        return (
            <div>
                {this.props.children}
            </div>
        );
    }
}

export default connect()(App);



// WEBPACK FOOTER //
// ./src/containers/App/index.tsx